import React, { useRef, useState, useEffect } from "react";
import "../../../components/Dashboard/Agency/PropertiesAgecny/propertiesagency.css";
import { getserviceticketspaginglist,quickupdateticketfromlist,bulkticketupdate,assignedTo,getticketdashboard } from "../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus, serviceCategory,ePriority } from "../../../Utilities/enum";
import AntdTableExample from "../../input-components/dataTable";
import SubNav from "../../navbar/subNav";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { PieChart, Pie, Cell, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from "recharts";
import "./dashboard.css"
import CustomModal from "../../input-components/Modal";
import { Button} from "antd";
import SelectBox from "../../input-components/selectBoxNew";
import { Dropdown } from "primereact/dropdown";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import { dynamicUrl } from "../../../Utilities/profileManagement";

const ServiceManagement = ({ handleparentsuccess }) => {
  const [activitiesList, setActivitiesList] = useState([]);
  const [userId, setUserId] = useState("");
  const [agencyID, setAgencyId] = useState("");
  const { showSpinner, hideSpinner } = useSpinnerContext();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [purpose, setPurpose] = useState(1);
  const [dpdata,setDpdata] = useState([]);
  const [assignToArr, setAssignToArr] = useState([]);
  const [viewDashboaard, setViewDashboard] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [docArray, setDocArray] = useState([
    { value: "Close", label: "Close" },
    { value: "AssignTo", label: "Assign To" },
    { value: "Delete", label: "Delete" },
  ]);
  const [selectedDoc, setSelectedDoc] = useState(""); // Track the selected doc
  const [selectedCity, setSelectedCity] = useState(null);
  const [ticketArr,setTicketArr] = useState([]);
  const [openTicketData,setOpenTicketData] = useState({});
  const [viewTable,setViewTable] = useState(true);

  const navigate = useNavigate();
  const ToastRef = useRef();

  useEffect(() => {
    const retrieveData = async () => {
      try {
        const userData = GetCookie("@UserData");
        if (userData) {
          const parsedData = JSON.parse(userData);
          setUserId(parsedData.userId);
          setAgencyId(parsedData.agencyID);
          reportData(parsedData.agencyUniqueID);
          getOpenTickets(parsedData.agencyID)
        }
      } catch (error) {
        console.error("Error retrieving data from AsyncStorage:", error);
      }
    };
    retrieveData();
  }, [userId]);

  useEffect(() => {
    if (userId) ListContactActivities(1, 10);
  }, [userId, purpose]);

  const getOpenTickets = (id) => {
    const baseUrl = getticketdashboard + `?AgencyId=${id}`;
    makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get")
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
         setOpenTicketData(response.object)
        } else {
          alert(`Message: ${response.message}`);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const reportData = (agencyUID) => {
    const apiUrl = assignedTo;
    const baseUrl = apiUrl + "?agencyUID=" + agencyUID;
    axios.get(baseUrl).then((response) => {
      if (response.data.object) setDpdata(response.data.object);
      const cleanedOptions = response?.data?.object?.map(({ text, value }) => ({
        label: text.replace(/\(.*?\)/g, "").trim(), // Removes content inside ()
        value: value,
      })); 
      setAssignToArr(cleanedOptions)
    });
  };

  const ListContactActivities = (currentPage, totalRows) => {
    const baseUrl = getserviceticketspaginglist;
    let data = {
      AgencyId: agencyID,
      SortBy: "AddedOn",
      SortOrder: "DESC",
      RecordsPerPage: totalRows,
      PageNo: currentPage,
      Status: purpose
    };
    makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          let serviceData = response.object.serviceTickets;
          let serviceList = serviceData
            .map((conatact) => ({
              subject: conatact.subject,
              requester: conatact.requesterName,
              State: conatact.isNew ? "New" : "-",
              Status: conatact.sStatus,
              Priority: conatact.sPriority,
              AssignedTo: conatact.assignAgentName,
              ticketUniqueId: conatact.ticketUniqueId,
              isNew: conatact.isNew,
              id:conatact.id
            }));
          setActivitiesList(serviceList);
          setTotalPages(response.totalCount);
        } else {
          alert(`Message: ${response.message}`);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handlePageChange = (event, pageNumber) => {
    ListContactActivities(event, 10);
    setFirst(event.first);
    setRows(event.rows);
  };

  const handleRow = (e, data) => {
    e.preventDefault(); // Prevent default browser behavior
    e.stopPropagation();
    dynamicUrl(navigate, `ViewServiceManagement?ticketUniqueId=${data.ticketUniqueId}&isNew=${data.isNew}&ticketId=${data.id}`);
    
  }

  const tabColumns = {
    State: {
      colorMap: {
        "New": "#58d68d",
      },
      defaultColor: '#85c1e9'
    }
  };

  const handleStatClick = (selectedPurpose) => {
    if(selectedPurpose === "Dashboard"){
      setViewDashboard(selectedPurpose)
      setPurpose("")
    }else{
      setPurpose(selectedPurpose);
      setViewDashboard("");
    }
  };


  const dynamicOptions = {
    Status: [
      { value: serviceCategory.Open, label: "Open" },
      { value: serviceCategory.Pending, label: "Pending" },
      { value: serviceCategory.Resolved, label: "Resolved" },
      { value: serviceCategory.Closed, label: "Closed" },
    ],
    Priority: [
      { value: serviceCategory.Open, label: "Low" },
      { value: serviceCategory.Pending, label: "Medium" },
      { value: serviceCategory.Resolved, label: "High" },
      { value: serviceCategory.Closed, label: "Urgent" },
    ],
    AssignedTo : assignToArr
  };

  const handleDynamicChange = (value, recordKey, columnKey,recordData) => {
    // Update the table data with the new value
    const updatedData = activitiesList.map(record =>
      record.key === recordKey ? { ...record, [columnKey]: value } : record
    );
    setActivitiesList(updatedData);
    submitColumnValue(value, recordKey, columnKey,recordData)
  };
  
  const submitColumnValue = (value, recordKey, columnKey, recordData) => {
    const baseUrl = quickupdateticketfromlist;
    const data = {
      TicketId: recordData.id,
      FieldName: columnKey,
      Value: value,
    };
  
    makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          ListContactActivities(1, 10)
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  

const onSelectedRowKeysChange = (e,data) => {
  setTicketArr(e)
}

const priorityData = [
  { name: "High", value: 1 },
  { name: "Low", value: 59 }
];


const COLORS = ["#FFA500", "#126284"];

const handleCancel = () => {
  setIsModalVisible(false)
}

const handleOpenMultiTickets = () => {
  setIsModalVisible(true)
}
  const handleAssignedTo = (e) => {
    setSelectedCity(e.value);
  };

  const handleTitle = (e) => {
    setSelectedDoc(e.value)
  }

  const submitMultiTickets = () => {
    const baseUrl = bulkticketupdate;
  
    if (selectedDoc === "") {
      ToastRef.current.notify(["error", "Title is required"]);
      return;
    }
  
    // Construct data object dynamically based on selectedDoc
    let data = {
      TicketIds: ticketArr,
    };
  
    if (selectedDoc === "Close") {
      data.Close = true;
    } else if (selectedDoc === "Delete") {
      data.Delete = true;
    } else {
      data.AssignTo = parseInt(selectedCity);
    }
  
    makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          ListContactActivities(1, 10);
          setIsModalVisible(false)
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  
  const barData1 = openTicketData?.ticketByAgents?.map(agent => ({
    name: agent.agentName,
    value: agent.ticketCount
}));

  return (
    <div>
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
          <SubNav title={"Tickets List - New & Open Tickets"} goback={false} extraData={true} extraContent={
                      <div className="property-details-buttons">
                        <button onClick={handleOpenMultiTickets} className="subnav-btn" type="submit">
                           Multi Tickets
                        </button>
                      </div>
                    } />
          <div className="material-work-desk-new bg-white m-3">
          <ToastAlert ref={ToastRef} />

            <div style={{ borderBottom: '1px solid #e9ecef', padding: '10px' }}>
              <div className="col-lg-8">
              <span
                  className={`col-lg-2 col-sm-2 stat-item ${viewDashboaard  === "Dashboard"? 'active' : ''}`}
                  onClick={() => handleStatClick("Dashboard")}
                >
                  Dashboard
                </span>
                <span
                  className={`col-lg-2 col-sm-2 stat-item ${purpose === serviceCategory.Open ? 'active' : ''}`}
                  onClick={() => handleStatClick(serviceCategory.Open)}
                >
                  Open
                </span>
                <span
                  className={`col-lg-2 col-sm-2 stat-item ${purpose === serviceCategory.Pending ? 'active' : ''}`}
                  onClick={() => handleStatClick(serviceCategory.Pending)}
                >
                  Pending
                </span>
                <span
                  className={`col-lg-2 col-sm-2 stat-item ${purpose === serviceCategory.Resolved ? 'active' : ''}`}
                  onClick={() => handleStatClick(serviceCategory.Resolved)}
                >
                  Resolved
                </span>
                <span
                  className={`col-lg-2 col-sm-2 stat-item ${purpose === serviceCategory.Closed ? 'active' : ''}`}
                  onClick={() => handleStatClick(serviceCategory.Closed)}
                >
                  Closed
                </span>

              </div>
            </div>
           {viewDashboaard !== "Dashboard" ?
            <div>
            <AntdTableExample
              dataSource={activitiesList}
              globalSearch
              hideCol={"ticketUniqueId,isNew"}
              onPageChange={handlePageChange}
              totalRows={rows}
              totalRecords={totalPages}
              showCheckbox
              tagColumns={tabColumns}
              dynamicOptions={dynamicOptions}
              onDynamicChange={handleDynamicChange}
              //actions={actions}
              onSelectedRowKeysChange={onSelectedRowKeysChange}
              onRowClick={handleRow}
            />
            </div>:
            <div>
            <div className="dashboard-container">
      {/* Cards Section */}
      <div className="card red">
        <p className="card-title">Overdue Tickets</p>
        <p className="card-value">27</p>
      </div>
      <div className="card blue">
        <p className="card-title">Tickets Due Today</p>
        <p className="card-value">1</p>
      </div>
      <div className="card open">
        <p className="card-title">Open Tickets</p>
        <p className="card-value">{openTicketData?.countOfOpenTicket}</p>
      </div>
      <div className="card hold">
        <p className="card-title">Tickets On Hold</p>
        <p className="card-value">24</p>
      </div>



    </div>
          {/* Charts Section */}
          <div className="charts-row">
        <div className="chart-container">
          <p className="chart-title">Unresolved Tickets by Priority</p>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie data={priorityData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>
                {priorityData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* <div className="chart-container">
          <p className="chart-title">Unresolved Tickets by Status</p>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie data={statusData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>
                {statusData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div> */}

        <div className="chart-container">
          <p className="chart-title">New & My Open Tickets</p>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={barData1} layout="vertical">
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" hide />
              <YAxis dataKey="name" type="category"  width={100}/>
              <Bar dataKey="value" fill="#d946ef" barSize={20} />
              <Tooltip />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
     
            </div>}

            <CustomModal
  title="Multi Tickets"
  visible={isModalVisible}
  onCancel={handleCancel}
  width={600}
  footer={[
    <Button className="mt-3" onClick={handleCancel} key="cancel">Cancel</Button>,
    <Button className="mt-3" onClick={submitMultiTickets} key="forward" type="primary">Submit</Button>,
  ]}
  modalData={
    <div>
      <SelectBox
        colVal={12}
        name="docTitle"
        value={selectedDoc}  // Store the selected value
        options={docArray}
        label={"Title"}
        onChange={(e) => handleTitle(e)} // Update state on change
        isMandatory
      />

      {/* Conditionally render the "Assigned To" field */}
      {selectedDoc === "AssignTo" && (
        <div className="cda-reportTo col-lg-12 col-sm-12">
          <label htmlFor="trading state" className="s1 w-100">
            Assigned To
          </label>
          <Dropdown
            value={selectedCity}
            onChange={handleAssignedTo}
            options={dpdata}
            optionLabel="text"
            placeholder="Assigned To"
            style={{
              width: "100%",
              height: "40px",
              display: "flex",
              alignItems: "center",
            }}
          />
        </div>
      )}
    </div>
  }
/>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceManagement;
